var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 5.21797C10.2692 5.21797 5.21803 10.2691 5.21803 16.5C5.21803 22.7309 10.2692 27.7821 16.5001 27.7821C22.731 27.7821 27.7821 22.7309 27.7821 16.5C27.7821 10.2691 22.731 5.21797 16.5001 5.21797ZM3.16675 16.5C3.16675 9.13622 9.13629 3.16669 16.5001 3.16669C23.8639 3.16669 29.8334 9.13622 29.8334 16.5C29.8334 23.8638 23.8639 29.8334 16.5001 29.8334C9.13629 29.8334 3.16675 23.8638 3.16675 16.5Z",
    fill: "#FFC44A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6026 21.6282C21.1691 21.6282 21.6283 21.169 21.6283 20.6026C21.6283 20.0361 21.1691 19.5769 20.6026 19.5769H12.3975C11.8311 19.5769 11.3719 20.0361 11.3719 20.6026C11.3719 21.169 11.8311 21.6282 12.3975 21.6282H20.6026Z",
    fill: "#FFC44A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.765 12.3975C13.765 13.1527 13.1528 13.765 12.3975 13.765C11.6423 13.765 11.03 13.1527 11.03 12.3975C11.03 11.6422 11.6423 11.0299 12.3975 11.0299C13.1528 11.0299 13.765 11.6422 13.765 12.3975Z",
    fill: "#FFC44A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9702 12.3975C21.9702 13.1527 21.3579 13.765 20.6026 13.765C19.8474 13.765 19.2351 13.1527 19.2351 12.3975C19.2351 11.6422 19.8474 11.0299 20.6026 11.0299C21.3579 11.0299 21.9702 11.6422 21.9702 12.3975Z",
    fill: "#FFC44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.b0968ce6027b8ece5083d69ca7e4cc92.svg";
export { ForwardRef as ReactComponent };